export default __webpack_public_path__ + "media/images/main/arrow-blue-8d42962c636d332c83b143c9ab931df5.png";